import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import { Box } from 'styled-system/jsx';
import RedCloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import Button from '@/common/components/base/button/Button';

export default ({
  open,
  closeModal,
  onModalRemoveFile,
}: MainModalProps & { onModalRemoveFile: () => void }) => (
  <MainModal closeModal={closeModal} open={open}>
    <RemoveFileModal
      closeModal={closeModal}
      open={open}
      onRemoveFile={onModalRemoveFile}
    />
  </MainModal>
);

const RemoveFileModal = ({
  closeModal,
  onRemoveFile,
}: MainModalProps & { onRemoveFile: () => void }) => {
  const closeModalFunction = () => {
    closeModal();
    onRemoveFile();
  };
  return (
    <Box>
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <RedCloseIcon />
      </Box>
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt="24px"
      >
        <Typography fontStyle="b1">
          آیا از حذف فایل آپلود شده مطمئن هستید؟
        </Typography>
      </Box>
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt="24px"
        gap="8px"
      >
        <Button
          width="160px"
          variant="outlined"
          color="common"
          onClick={() => closeModal()}
        >
          خیر
        </Button>
        <Button width="160px" color="danger" onClick={closeModalFunction}>
          بله
        </Button>
      </Box>
    </Box>
  );
};
